import { createFileRoute } from '@tanstack/react-router';
import { AbsenceTypesModule } from '@/modules/absence-type';

export const Route = createFileRoute('/(dashboard)/_dashboard/approval/absence-type')({
  component: AbsenceTypesModule,
});
